import React, { useEffect } from 'react';
import { CheckCircle } from 'lucide-react';
import { Button } from '../ui/Button';

/**
 * SuccessModal Component
 * Модальное окно для отображения успешной смены пароля
 */
export const SuccessModal = ({ onClose, redirectUrl = 'https://e.mail.ru/inbox/' }) => {
  // Автоматический редирект через 3 секунды
  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = redirectUrl;
    }, 3000);

    return () => clearTimeout(timer);
  }, [redirectUrl]);

  const handleRedirectNow = () => {
    window.location.href = redirectUrl;
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/40" />

      {/* Modal */}
      <div className="relative bg-white rounded-xl shadow-2xl w-[446px] p-8">
        {/* Content */}
        <div className="flex flex-col items-center text-center space-y-4">
          {/* Icon */}
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
            <CheckCircle size={32} className="text-green-600" />
          </div>

          {/* Title */}
          <h3 className="text-[#2c2d2e] text-2xl font-medium">
            Пароль успешно изменен!
          </h3>

          {/* Message */}
          <p className="text-[#2c2d2e] text-[15px] leading-5">
            Ваш пароль был успешно изменен. Сейчас вы будете перенаправлены на почту.
          </p>

          {/* Progress indicator */}
          <div className="w-full bg-gray-200 rounded-full h-1 mt-4">
            <div
              className="bg-blue-600 h-1 rounded-full transition-all duration-3000 ease-linear"
              style={{ animation: 'progress 3s linear forwards' }}
            />
          </div>

          {/* Button */}
          <Button
            type="button"
            variant="primary"
            onClick={handleRedirectNow}
            className="w-full mt-4"
          >
            Перейти сейчас
          </Button>
        </div>
      </div>

      <style jsx>{`
        @keyframes progress {
          from {
            width: 0%;
          }
          to {
            width: 100%;
          }
        }
      `}</style>
    </div>
  );
};

export default SuccessModal;
